import { transactionQuery, systemStateQuery } from '~services/subgraph/queries';

export const troveQuery = `
troves(where: { asset: $asset }) {
    id
    status
    collateral
    debt
    rawCollateral
    rawDebt
    changes {
      ${transactionQuery}
      collateralBefore
      collateralChange
      collateralAfter
      debtBefore
      debtChange
      debtAfter
      borrowingFee
    }
}`;

export const stabilityQuery = `
stabilityDeposits(where: { asset: $asset }) {
    id
    asset
    owner { 
        id 
    }
    depositedAmount
    changes(where: { asset: $asset }) {
        id
        ${transactionQuery}
    }
  }`;

export const liquidationQuery = `
liquidations(where: { asset: $asset }) {
    id
    asset {
        id
    }
    sequenceNumber
    ${transactionQuery}
    liquidator { 
        id 
    }
    liquidatedDebt
    liquidatedCollateral
    collGasCompensation
    tokenGasCompensation
    troveChanges {
      id
      asset
      borrowingFee
      ${transactionQuery}
      ${systemStateQuery}
  }
}`;

export const redemptionsQuery = `
redemptions(where: { asset: $asset }) {
    id
    asset {
        id 
    }
    sequenceNumber
    ${transactionQuery}
    redeemer { 
        id 
    }
    tokensAttemptedToRedeem
    tokensActuallyRedeemed
    collateralRedeemed
    partial
    fee
    troveChanges {
        id
        asset
        borrowingFee
        ${transactionQuery}
        ${systemStateQuery}
    }
}`;

export const balancesQuery = `
balances {
    id
    token
    owner
    balance
}`;

export const allowancesQuery = `
allowances(where: { token: $asset }) {
    id
    token
    owner
    spender
    value
}`;
